// extracted by mini-css-extract-plugin
export var container = "_cy-0";
export var popoverContent = "_cy-1";
export var tosLink = "_cy-2";